const { default: ControlledCarousel } = require("../../components/Carousels/Carousels")


const IndexPage = () => {

    return(
        <>
        <ControlledCarousel />
        </>
    )
}

export default IndexPage